import "react-toastify/dist/ReactToastify.css";
import React, { ReactNode } from "react";
import NavMenu from "../NavMenu/NavMenu";
import TopBar from "../../common/TopBar/TopBar";
import useScreenWidth from "../../store/useScreenWidth";
import { useLocation } from "react-router-dom";
import { EndPoints } from "../../utils/apiEndpoints";
import { useUserStore } from "../../store/useUserStore";
import { useExpandNavMenu } from "../../store/useExpandNavMenu";

interface LayoutProps {
  children: ReactNode;
}
export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();

  const isSmallScreen = useScreenWidth();

  const { user } = useUserStore();
  const { isCollapsed } = useExpandNavMenu();

  const condition = user && user.emailConfirmed === "True" && location.pathname !== EndPoints.CONFIRMEMAIL;

  return location.pathname === EndPoints.ONBOARDING ? (
    <div>{children}</div>
  ) : condition ? (
    <div className={`position-relative d-flex flex-row w-100 ${isSmallScreen && "p-3"}`}>
      {!isSmallScreen && <NavMenu />}
      <div className="d-flex flex-row justify-content-center w-100">
        <div
          className="d-flex flex-column"
          style={
            isSmallScreen ? { width: "100%" } : { width: isCollapsed ? "calc(75vw - 80px)" : "calc(90vw - 250px)" }
          }
        >
          <TopBar />
          {children}
        </div>
      </div>
    </div>
  ) : (
    <div className="d-flex align-items-center justify-content-center w-100">{children}</div>
  );
};
